/**
 * Clamps a number between min and max values
 * @param value - Input number
 * @param min - Minimum allowed value
 * @param max - Maximum allowed value
 * @returns Number clamped between [min, max]
 */
export function clampNumber(
  value: number | undefined,
  min: number,
  max: number,
): number {
  if (value === undefined || Number.isNaN(value)) return min
  return Math.min(Math.max(value, min), max)
}
